const S3_BASE_URL = 'https://offshore2go-documents.s3.us-east-2.amazonaws.com/';

export const companyLogoUrl = (logoPath?: string | null): string | null => {
  if (!logoPath) {
    return null;
  }

  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }

  return `${S3_BASE_URL}${logoPath.replace(/^\//, '')}`;
};
